import React, { FC } from 'react'
import { t, Trans } from '@lingui/macro'

import { ButtonType } from 'components/buttons/LinkIconButton/LinkIconButton'

import { LinkButton } from 'components/buttons/LinkButton/LinkButton'
import styles from './GameScheduleButtons.module.scss'
interface NoBroadcastLabelProps {
  id?: string
  channelSlug?: string
}

export const NoBroadcastLabel: FC<NoBroadcastLabelProps> = ({
  id,
  channelSlug
}) => {
  if (!id || !channelSlug) {
    return (
      <div className={styles.NoBroadcastLabel}>
        <Trans>No broadcast</Trans>
      </div>
    )
  }
  return (
    <div data-testid="no-broadcast-label">
      <LinkButton
        type={ButtonType.Secondary}
        buttonSize="Small"
        label={t`No broadcast`}
        link={`/${channelSlug}/games/g/${id}`}
      ></LinkButton>
    </div>
  )
}
